module.exports = __webpack_public_path__ + "img/宏发.75db56d8.jpg";